import { Delete, Edit } from "@mui/icons-material";
import { ListItemIcon, Menu, MenuItem, ListItemText } from "@mui/material";
import { WorkflowNode } from "../../types/workflow";
import { Help } from "../../svgUrls";

type WorkflowMenuProps = {
    menuAnchorEl: SVGSVGElement | null;
    setMenuAnchorEl: React.Dispatch<React.SetStateAction<SVGSVGElement | null>>;
    workflowNode: WorkflowNode;
    deleteNodeById: (params: { nodeId: string }) => void;
    shouldDeleteNode: () => void;
    refreshWorkflowNodes: () => void;
    hasChildren: boolean;
    onStartRename?: () => void;
};

const WorkflowBoxMenu = ({
    menuAnchorEl,
    setMenuAnchorEl,
    workflowNode,
    deleteNodeById,
    shouldDeleteNode,
    refreshWorkflowNodes,
    hasChildren,
    onStartRename
}: WorkflowMenuProps) => {
    return (
        <Menu
            anchorEl={menuAnchorEl}
            open={Boolean(menuAnchorEl)}
            disableAutoFocusItem
            onClose={() => setMenuAnchorEl(null)}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
        >
            <MenuItem
                onClick={() => {
                    setMenuAnchorEl(null);
                    if (workflowNode.node.id) {
                        deleteNodeById({ nodeId: workflowNode.node.id });
                    }
                }}
                className="!text-xs !text-[#C05353]"
            >
                <ListItemIcon className="mr-2 !min-w-0">
                    <Delete className="!text-sm" htmlColor="#C05353" />
                </ListItemIcon>
                Delete node
            </MenuItem>
            <MenuItem
                onClick={() => {
                    onStartRename?.();
                    setMenuAnchorEl(null);
                }}
                className="!text-xs"
            >
                <ListItemIcon className="mr-2 !min-w-0">
                    <Edit fontSize="small" />
                </ListItemIcon>
                Rename
            </MenuItem>
            <MenuItem
                onClick={() => {
                    setMenuAnchorEl(null);
                }}
                className="!text-xs"
            >
                <ListItemIcon className="mr-2 !min-w-0">
                    <Help className="w-[15px]" />
                </ListItemIcon>
                Troubleshoot
            </MenuItem>
        </Menu>
    )
};

export default WorkflowBoxMenu;